import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { style } from '../../utils/style.js';
const GOLDEN_RATIO = 1.618;
export const Shimmer = JSX(({ className, size }) => (_jsx("figure", { className: style('m-0 mt-xl min-w-[80%]', className), children: renderShimmer(size) })));
const renderShimmer = (size = 3) => goldenSequence(100, size)
    .map((_) => Math.floor(_))
    .map(renderShimmerItem);
const renderShimmerItem = (width, index) => (_jsx("div", { style: { width: `${width || 100}%` }, className: "h-4 mt-xs bg-secondary-dark relative overflow-hidden animate-pulse" }, String(index)));
const goldenSequence = (first, size) => [first].concat(size > 0 ? goldenSequence(first / GOLDEN_RATIO, size - 1) : []);
//# sourceMappingURL=Shimmer.js.map